<template>
      <div v-if="propertyGroup.group" :class="paddingClasses" class="bg-lightblue  px-2 py-2" :style="paddingInlineStyles">
        <div class="h4" v-html="propertyGroup.group.names.name">
        </div>
        <div class="position-relative">
            <div>
              <div class="input-unit order-property-input">
                <select v-model="selectionValue" @change="onInputValueChanged()" class="custom-select p-3">
                  <template v-for="property in propertyGroup.properties">
                    <option
                        :value="property.id"
                        :key="property.id">
                      {{ property.names.name }}
                      <template v-if="surcharge(property) > 0">
                        (+ {{ surcharge(property) | currency }})
                      </template>
                    </option>
                  </template>
                </select>
              </div>
            </div>
          </div>
      </div>
</template>

<script>
import OrderPropertyListItemCustom from "./OrderPropertyListItemCustom.vue";
import {isNullOrUndefined} from "../helper/utils";
import {mapState} from "vuex";

export default {
  name: "order-property-list-group-custom",

  inject: {
    itemId: {
      default: null
    }
  },
  components:
  {
    OrderPropertyListItemCustom,
  },
  data()
  {
    return {
      selectionValue: null
    }
  },
    props:
    {
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        propertyGroup: Object
    },
  created() {
    console.log('cr',this.propertyGroup)
    this.selectionValue = this.propertyGroup.properties[0].id
    this.onInputValueChanged()
  },
  computed:
    {
      ...mapState({
        basketItems: state => state.basket.items,
        isBasketLoading: state => state.basket.isBasketLoading,
      }),
      // variationMarkInvalidProperties() {
      //   return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationMarkInvalidProperties;
      // },
      // isShownOnItemPageCount()
      // {
      //     const properties = this.propertyGroup.properties.filter(property => property.isShownOnItemPage);
      //
      //     return properties.length;
      // }
    },
    methods:{
      // hasError()
      // {
      //   return  this.variationMarkInvalidProperties ;
      // },
      //
      surcharge(property)
      {
        return property.itemSurcharge || property.surcharge;
      },
      setVariationOrderProperty(orderProperty) {
        return this.$store.commit(`${this.itemId}/setVariationOrderProperty`, orderProperty);
      },
      onInputValueChanged()
      {
        console.log(this.selectionValue)
        for(let i = 0 ; i  < this.propertyGroup.properties.length ; i++)
        {
          if(this.propertyGroup.properties[i].id != this.selectionValue)
          {
            // this.setVariationOrderProperty({ propertyId: this.propertyGroup.properties[i].id, value: [] });
          }
          else{
            this.setVariationOrderProperty({ propertyId: this.selectionValue, value: this.selectionValue });
            this.$store.commit(`${this.itemId}/setVariationPropertySurcharges`, this.$store.getters[`${this.itemId}/variationBasePrice`]);
          }
        }
      },
    }
}
</script>
